module.exports = __webpack_public_path__ + "img/poly-7.f77c57a3.png";